import { MADE_FOR_YOU_TYPES } from '~scenes/madeforyou/constants';


const getStateForAllTabs = (initialValue) => MADE_FOR_YOU_TYPES.reduce((acc, type) => ({
    ...acc,
    [type]: initialValue,
}), {});

/**
 * @constant {initialState}
 */
const initialState = {
    activeTab: MADE_FOR_YOU_TYPES[0],
    tabList: MADE_FOR_YOU_TYPES,
    betCards: [],
    currentPage: 1,
    isLoading: getStateForAllTabs(false),
    isError: getStateForAllTabs(null),
    isMadeForYouWidget: false,
};

export default initialState;
